const initialState = {routerblock: false};

export const routerblock = {
  namespaced: true,
  state: initialState,
  actions: {
  },
  mutations: {
    updateRouterblock(state, payload) {
      state.routerblock = payload;
    },
  },
};
